import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';

@Component({
  selector: 'app-modal-costing-tool',
  templateUrl: './modal-costing-tool.component.html',
  styleUrls: ['./modal-costing-tool.component.scss']
})
export class ModalCostingToolComponent implements OnInit {


  @Input() enquiryNo!: string;
  @Input() item!: EnquiryHeaderItem;
  @Input() origin!: string;
  @Input() useNearestMatch: boolean = false;
  @Input() costsSourceCostingToolRecordId: number | null = null;
  @Input() costsSourceCostingToolVersionId: number | null = null;
  @Input() unitSystem?: string | null;
  @Input() currency?: string | null;

  @Output() onClose: EventEmitter<any> = new EventEmitter();


  ngOnInit(): void {
  }

  onCloseCostingTool() {
    this.onClose.emit();
  }

}
